import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Button, Form, Input, Modal } from "antd";
import moment from "moment";

import colorSyntax from "@toast-ui/editor-plugin-color-syntax";
import { Editor } from "@toast-ui/react-editor";

import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";

const BoardChannelComment = ({ getInfo, channelInfo, item, type }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const editorRef = useRef(null);
	const editorEditRef = useRef(null);
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [secretModalShow, setSecretModalShow] = useState(false);

	const [secretShow, setSecretShow] = useState(false);
	const [secretAnswer, setSecretAnswer] = useState({});
	const [valid, setValid] = useState({
		phone: true,
		password: true,
	});
	const [searchValue, setSearchValue] = useState({
		phone: "",
		password: "",
	});

	const [replyModal, setReplyModal] = useState(false);
	const [replyEdit, setReplyEdit] = useState(false);

	const toolbarItems = [
		["heading", "bold", "italic", "strike"],
		["link", "code"],
		// ['table', 'link'],
		["hr"],
		["ul", "ol", "task"],
		// ['image'],
		// ['code'],
		["scrollSync"],
	];
	useEffect(() => {
		if (item?.reply) {
			setSecretAnswer(item.reply);
		}
	}, [item]);

	/**
	 * 댓글 확인
	 */
	const handleCommentShow = () => {
		setSecretModalShow(true);
		setSearchValue({
			phone: "",
			password: "",
		});
		setValid({
			phone: true,
			password: true,
		});
	};

	/**
	 * 비밀글 조회 클릭
	 * @returns {(function(): void)|*}
	 */
	const handleSecretOk = async () => {
		setIsLoading(true);
		let param = {
			commentId: item.id,
			phoneCenter: searchValue.phone,
			password: searchValue.password,
		};
		const res = await partnersApi.readSecret(param);
		if (res.code === 200) {
			setSecretModalShow(false);
			setSecretShow(true);
			setSecretAnswer(res.result);
		} else {
			setValid({
				phone: false,
				password: false,
			});
		}
		setIsLoading(false);
	};

	/**
	 * 답글 달기
	 * @returns {Promise<void>}
	 */
	const handleReply = async () => {
		setIsLoading(true);
		let reply = editorRef?.current?.getInstance().getHTML();
		let param = {
			comment_id: item.id,
			created_by: user.id,
			content: reply,
			influencer_id: reduxChannel?.user_id,
		};
		const res = await partnersApi.createReply(param);
		if (res.code === 200) {
			getInfo();
			setReplyModal(false);
		}
		setIsLoading(false);
	};

	/**
	 * 답글 수정
	 * @returns {Promise<void>}
	 */
	const handleReplyEdit = async () => {
		setIsLoading(true);
		let reply = editorEditRef?.current?.getInstance().getHTML();
		let param = {
			id: item.reply.id,
			comment_id: item.id,
			created_by: user.id,
			content: reply,
		};
		const res = await partnersApi.createReply(param);
		if (res.code === 200) {
			getInfo();
			setReplyEdit(false);
		}
		setIsLoading(false);
	};

	return (
		<>
			<span className={`phone`}>
				{item.phone?.slice(0, 3)}
				****
				{item.phone?.slice(7, 11)}
			</span>
			<div className={`comment-group`}>
				{!item.is_secret || secretShow || type === "edit" ? (
					<span
						style={{
							fontWeight: 300,
							whiteSpace: "pre-wrap",
						}}
					>
						{item.content}
					</span>
				) : (
					<div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
						<img
							src={`/assets/images/channel/secret.png`}
							alt={`비밀댓글`}
							style={{
								width: "13px",
								height: "auto",
							}}
						/>
						<span className={`created_at`}>비밀글입니다</span>
						<Button size={`small`} onClick={handleCommentShow}>
							댓글확인
						</Button>
					</div>
				)}
				{type === "edit" && !item?.is_answer && (
					<Button size={`small`} onClick={() => setReplyModal(!replyModal)}>
						답글쓰기
					</Button>
				)}
			</div>
			<span
				className={`created_at`}
				style={{
					fontSize: "0.9em",
				}}
			>
				{moment(item.updated_at)?.format("YY.MM.DD")}
			</span>
			{item?.is_answer && (
				<div className={`comment-answer`}>
					<div className={`comment-user`}>
						{/*<img*/}
						{/*    src={`/assets/images/channel/reply.png`}*/}
						{/*    alt={`답변 아이콘`}*/}
						{/*/>*/}
						<div className={`channel-img`}>
							<img
								src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${channelInfo?.id}.${channelInfo?.profile_img_type}`}
								// src={`/assets/images/channel/doctor.png`}
								onError={({ currentTarget }) => {
									currentTarget.onerror = null; // prevents looping
									// currentTarget.style.display = "none";
									currentTarget.src = `/assets/images/channel/basic.png`;
								}}
								className={`channel-img`}
								alt={`채널 이미지`}
							/>
							{/*<img*/}
							{/*    src={`/assets/images/channel/user-star.png`}*/}
							{/*    alt={`유저 별표`}*/}
							{/*    className={`user-star`}*/}
							{/*/>*/}
						</div>
						<span>{channelInfo?.nickname}</span>
					</div>
					{secretShow || type === "edit" ? (
						<div
							className={`comment-secret`}
							style={{ flexDirection: "column", alignItems: "flex-start" }}
						>
							<span
								className={`show-answer`}
								style={{
									fontWeight: 300,
									width: "100%",
								}}
								dangerouslySetInnerHTML={{
									__html: secretAnswer?.content,
								}}
							/>
							{type === "edit" && (
								<Button
									size={`small`}
									onClick={() => setReplyEdit(!replyEdit)}
									style={{
										margin: "4px 0",
									}}
								>
									댓글수정
								</Button>
							)}
							<Link to={`${item.answer_link}`}>{item.answer_link}</Link>
							<span
								className={`created_at`}
								style={{
									fontSize: "0.9em",
								}}
							>
								{moment(secretAnswer?.updated_at)?.format("YY.MM.DD")}
							</span>
						</div>
					) : (
						<div
							className={`comment-secret`}
							style={{
								gap: "4px",
							}}
						>
							<img
								src={`/assets/images/channel/secret.png`}
								alt={`비밀댓글`}
								style={{
									width: "13px",
									height: "auto",
								}}
							/>
							<span className={`created_at`}>비밀댓글입니다</span>
							<Button size={`small`} onClick={handleCommentShow}>
								댓글확인
							</Button>
						</div>
					)}
				</div>
			)}

			{/* 비밀 댓글 확인 */}
			<Modal
				title="비밀 댓글 확인하기"
				wrapClassName="order-detail-modal-wrap channel-modal"
				open={secretModalShow}
				centered={true}
				onCancel={() => setSecretModalShow(!secretModalShow)}
				width="25%"
				cancelText={<span>취소</span>}
				okText={<span>조회</span>}
				onOk={handleSecretOk}
				confirmLoading={isLoading}
			>
				<Form layout={`vertical`}>
					<Form.Item
						label="휴대폰 번호 가운데 4자리"
						labelAlign="left"
						colon={false}
						required
					>
						<Input
							type={`text`}
							placeholder={`휴대폰 번호 가운데 4자리를 입력해주세요.`}
							value={searchValue.phone}
							onChange={(e) => {
								setSearchValue({
									...searchValue,
									phone: e.target.value,
								});
							}}
							style={!valid.phone ? { borderColor: "#fe2b4b" } : {}}
						/>
					</Form.Item>
					<Form.Item label="비밀번호" labelAlign="left" colon={false} required>
						<Input
							type={`text`}
							placeholder={`비밀번호를 입력해주세요.`}
							value={searchValue.password}
							onChange={(e) => {
								setSearchValue({
									...searchValue,
									password: e.target.value,
								});
							}}
							style={!valid.password ? { borderColor: "#fe2b4b" } : {}}
						/>
					</Form.Item>
				</Form>
			</Modal>

			{/* 답글 댓글 쓰기 */}
			<Modal
				title="답글쓰기"
				wrapClassName="order-detail-modal-wrap"
				open={replyModal}
				centered={true}
				onCancel={() => setReplyModal(!replyModal)}
				width="45%"
				cancelText={<span>취소</span>}
				okText={<span style={{ color: "white" }}>작성완료</span>}
				onOk={handleReply}
				confirmLoading={isLoading}
			>
				<Editor
					ref={editorRef}
					initialValue={item?.reply?.content || ""} // 글 수정 시 사용
					// initialValue={contentTitle.content || ""} // 글 수정 시 사용
					initialEditType="wysiwyg" // wysiwyg & markdown
					previewStyle={window?.innerWidth > 1000 ? "vertical" : "tab"} // tab, vertical
					hideModeSwitch={true}
					theme={""} // '' & 'dark'
					usageStatistics={false}
					toolbarItems={toolbarItems}
					useCommandShortcut={true}
					plugins={[colorSyntax]}
					language="ko-KR"
				/>
			</Modal>

			{/* 답글 댓글 수정 */}
			<Modal
				title="답글수정"
				wrapClassName="order-detail-modal-wrap"
				open={replyEdit}
				centered={true}
				onCancel={() => setReplyEdit(!replyEdit)}
				width="45%"
				cancelText={<span>취소</span>}
				okText={<span style={{ color: "white" }}>수정완료</span>}
				onOk={handleReplyEdit}
				confirmLoading={isLoading}
			>
				<Editor
					ref={editorEditRef}
					initialValue={item?.reply?.content || ""} // 글 수정 시 사용
					initialEditType="wysiwyg" // wysiwyg & markdown
					previewStyle={window?.innerWidth > 1000 ? "vertical" : "tab"} // tab, vertical
					hideModeSwitch={true}
					theme={""} // '' & 'dark'
					usageStatistics={false}
					toolbarItems={toolbarItems}
					useCommandShortcut={true}
					plugins={[colorSyntax]}
					language="ko-KR"
				/>
			</Modal>
		</>
	);
};
export default BoardChannelComment;
